"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionOneV2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_slick_1 = __importDefault(require("react-slick"));
var globalFuncionts_1 = require("@utils/globalFuncionts");
var Button_1 = __importDefault(require("../../../../components/Button"));
var styles_1 = require("./styles");
function SectionOneV2() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        easing: 'ease-in-out',
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsxs)(react_slick_1.default, __assign({}, settings, { children: [(0, jsx_runtime_1.jsxs)(styles_1.SliderOne, { children: [(0, jsx_runtime_1.jsx)(styles_1.Content, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h1", { children: "La pasarela de pagos ideal para ti" }), (0, jsx_runtime_1.jsxs)("p", { children: ["Facilita los cobros de tu negocio con nuestra", ' ', (0, jsx_runtime_1.jsx)("span", { children: "pasarela de pagos" }), " GBC."] }), (0, jsx_runtime_1.jsx)(_ButtonRedirectToWhatsApp, {})] }) }), (0, jsx_runtime_1.jsxs)(styles_1.ContentBannerCost, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { children: "Gs." }), (0, jsx_runtime_1.jsx)("p", { children: "0" })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Costo de ", (0, jsx_runtime_1.jsx)("br", {}), " afiliaci\u00F3n"] }), (0, jsx_runtime_1.jsx)("p", { children: "Costo de mantenimiento" })] })] })] }), (0, jsx_runtime_1.jsx)(styles_1.SliderTwo, { children: (0, jsx_runtime_1.jsxs)(styles_1.ContentSliderTwo, { children: [(0, jsx_runtime_1.jsx)("h1", __assign({ style: { textAlign: 'right' } }, { children: "Libre de cargos por mantenimiento Gs. 0" })), (0, jsx_runtime_1.jsxs)("p", { children: ["\u00A1Gana m\u00E1s con tu ", (0, jsx_runtime_1.jsx)("br", {}), " ", (0, jsx_runtime_1.jsx)("span", { children: "pasarela de pagos GBC" }), "!"] }), (0, jsx_runtime_1.jsx)(_ButtonRedirectToWhatsApp, {})] }) })] })), (0, jsx_runtime_1.jsxs)(styles_1.SloganText, { children: [(0, jsx_runtime_1.jsx)("span", { children: "GBC" }), " Conectamos con tu negocio"] })] }));
}
exports.SectionOneV2 = SectionOneV2;
function _ButtonRedirectToWhatsApp() {
    return ((0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "purple", onClick: function () {
            return (0, globalFuncionts_1.onOpenWhatsAppContactGbc)('Hola, quisiera afiliarme a la pasarela de pagos Gbc');
        } }, { children: "\u00A1Afiliarme ahora!" })));
}
